import React from "react";
import PropTypes from "prop-types";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import classes from "./AfterBackImages.module.scss";
import { InputLabel } from "../../../../../../../shared/InputLabel/InputLabel";
import { ImageUploader } from "../../../../../../../boxes/ImageUploader/ImageUploader";
import {
  IMAGE_COMPRESS_WIDTH,
  IMAGE_UPLOAD_TYPE,
} from "../../CosmeticCreateEdit.consts";
import { useDefaultImage } from "../../hooks/useDefaultImage";
import { useImageUploader } from "../../../../../../../hooks/useImageUploader";

export function AfterBackImages({
  backImage,
  leftImage,
  rightImage,
  onUploadingChange,
}) {
  const { tClients } = useAppTranslation.Clients();
  const defaultImage = useDefaultImage();

  const uploader = useImageUploader({
    distinguishByName: true,
    uploadType: IMAGE_UPLOAD_TYPE,
    onLoadingChange: onUploadingChange,
    compress: {
      width: IMAGE_COMPRESS_WIDTH,
    },
  });

  return (
    <div>
      <div className={classes.title}>
        {tClients("createEditCosmeticProcedure.images.afterBackImages")}
      </div>
      <div className={classes.images}>
        <div>
          <InputLabel>
            {tClients("createEditCosmeticProcedure.images.backImage")}
          </InputLabel>
          <ImageUploader
            name="afterBackImage"
            value={backImage.value}
            isLoading={
              uploader.isLoading && uploader.uploadingName === "afterBackImage"
            }
            onChange={(e) =>
              uploader
                .htmlOnChange(e)
                .then((res) => backImage.onChange(res?.uploadedFileFullPath))
            }
            onRemove={() => backImage.onChange(null)}
            defaultImage={defaultImage}
          />
        </div>
        <div>
          <InputLabel>
            {tClients("createEditCosmeticProcedure.images.backLeft45deg")}
          </InputLabel>
          <ImageUploader
            name="afterBackLeftImage"
            value={leftImage.value}
            isLoading={
              uploader.isLoading &&
              uploader.uploadingName === "afterBackLeftImage"
            }
            onChange={(e) =>
              uploader
                .htmlOnChange(e)
                .then((res) => leftImage.onChange(res?.uploadedFileFullPath))
            }
            onRemove={() => leftImage.onChange(null)}
            defaultImage={defaultImage}
          />
        </div>
        <div>
          <InputLabel>
            {tClients("createEditCosmeticProcedure.images.backRight45deg")}
          </InputLabel>
          <ImageUploader
            name="afterBackRightImage"
            value={rightImage.value}
            isLoading={
              uploader.isLoading &&
              uploader.uploadingName === "afterBackRightImage"
            }
            onChange={(e) =>
              uploader
                .htmlOnChange(e)
                .then((res) => rightImage.onChange(res?.uploadedFileFullPath))
            }
            onRemove={() => rightImage.onChange(null)}
            defaultImage={defaultImage}
          />
        </div>
      </div>
    </div>
  );
}

AfterBackImages.propTypes = {
  backImage: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  leftImage: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  rightImage: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  isLoading: PropTypes.bool,
};
